import axios from 'axios';

export function SetComponentLanguage(LocalizedStrings, en, fr) {
    const strings = new LocalizedStrings({ en, fr });
    const language = localStorage.getItem('showtix4u-lang') ? localStorage.getItem('showtix4u-lang') : 'en';
    strings.setLanguage(language);
    return strings;
}

export function GetAppLanguage() {
    return localStorage.getItem('showtix4u-lang') ? localStorage.getItem('showtix4u-lang') : 'en';
}

export function GetNearestTableAncestorId(node) {
    while (node) {
        node = node.parentNode;
        if (node.tagName === 'TABLE') {
             return node.id;
        }
    }
    return false;
}

export async function ApiRequest(path, options = {}) {
    return axios({
        url: `${process.env.REACT_APP_SHOWTIX4U_API_HOST}${path}`,
        data: options.data,
        method: options.method || 'get',
        withCredentials: true,
        headers: {
            Accept: 'application/json',
            'Content-Type': options.contentType || 'application/json'
        }
    });
}

export function parsePrinterXML(printersXML) {
    const cleanXML = printersXML.replace(/\\/g, '');
    const relevantXML = cleanXML.split('<Printers>').pop().split('</Printers>').shift();    
    const parsedXML = new DOMParser().parseFromString(relevantXML, "text/xml");
    const printerCollection = parsedXML.getElementsByTagName('Name');
    const printers = [];
    for (let printer of printerCollection) {
        printers.push(printer.textContent);
    }
    return printers;
} 

export function GroupBy(arr, property) {
    return arr.reduce((memo, x) => {
        if (!memo[x[property]]) { memo[x[property]] = []; }
        memo[x[property]].push(x);
        return memo;
    }, {});
}

export function DeepCopy(object) {
    return JSON.parse(JSON.stringify(object));
}

export function ReturnLegendClass(type) {
    switch (type) {
        case 'W':
            return 'wheelchair';
        case 'H':
            return 'handicap';
        case 'U':
            return 'unavailable';
        case 'C':
            return 'companion';
        case 'E':
            return 'empty';
        case 'O':
            return 'obstructed';
        default:
            return '';
    }
}

export function ReturnSeatStatusClass(status, user, social_distance) {
    if(!user.role) {
        if (social_distance) {
            return 'social-distance';
        } else {
            switch (status) {
                case 'reserved':
                    return 'reserved';
                case 'held':
                    return 'sold';
                default:
                    return status;
            }
        }  
    } else {
        return status;
    }
}

export function ReturnSeatStatus(status, social_distance) {
    /* if (social_distance) {
        return 'social-distance';
    } else { */
        return status;
    //}
}

export function Debounce(a, b, c) { var d, e; return function () { function h() { d = null, c || (e = a.apply(f, g)) } var f = this, g = arguments; return clearTimeout(d), d = setTimeout(h, b), c && !d && (e = a.apply(f, g)), e } }

export function ReturnTimeZone(timezone) {
    switch (timezone) {
        case 'AST':
            return 'America/Blanc-Sablon';
        case 'EST':
            return 'America/New_York';
        case 'CST':
            return 'America/Chicago';
        case 'MST':
            return 'America/Denver';
        case 'PST':
            return 'America/Los_Angeles';
        case 'AKST':
            return 'America/Anchorage';
        case 'HAST':
            return 'Pacific/Honolulu';
        case 'JST':
            return 'Asia/Tokyo';
        default:
            return timezone;
    }
}

export function GetTimezoneName(venueTimezone) {
    let momentTimezone = 'America/Montreal';
    switch(venueTimezone) {
        case 'AST':
        momentTimezone = 'America/Montreal';
        break;

        case 'EST':
        momentTimezone = 'US/Eastern';
        break;

        case 'CST':
        momentTimezone = 'US/Central';
        break;

        case 'MST':
        momentTimezone = 'US/Mountain';
        break;

        case 'PST':
        momentTimezone = 'US/Pacific';
        break;

        case 'AKST':
        momentTimezone = 'US/Alaska';
        break;

        case 'HAST':
        momentTimezone = 'US/Hawaii';
        break;

        case 'JST':
        momentTimezone = 'Asia/Tokyo';
        break;
    }

    return momentTimezone;
};

var setConsole = (function () {
    let debugUrlParamIsFalse = !getQueryVariable('debug') || getQueryVariable('debug') === "false";
    let isCheckinPage = window.location.href.indexOf("/checkin/") > -1;
    let doNotUseConsole =
        (process.env.REACT_APP_ENV_CONTEXT === 'production' && debugUrlParamIsFalse && !isCheckinPage)
        || (process.env.REACT_APP_ENV_CONTEXT !== 'production' && window.location.href.indexOf("debug") > -1 && debugUrlParamIsFalse && !isCheckinPage);

    if (doNotUseConsole) {
        var __no_op = function() {};

        window.console.log = __no_op;
    }

    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
        }
        return(false);
    }
}());

export function getUrlParams(search: string) {
    const hashes = search.slice(search.indexOf('?') + 1).split('&');
    const params = {};
    hashes.map((hash: string) => {
        const [key, val] = hash.split('=');
        return (params[key] = decodeURIComponent(val));
    });
    return params;
}

export function generateUID() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

export function generateUuidv4 () {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
};


// WEBPACK FOOTER //
// ./src/helpers.js